import { _decorator, Enum, CCInteger } from 'cc';
import { DEV } from 'cc/env';
import BaseAction from './BaseAction';

const { ccclass, property } = _decorator;

export enum AudioType {
    Effect,
    Music,
}
export enum AudioActionType {
    Play,
    Stop,
}

@ccclass('AudioAction')
export default class AudioAction extends BaseAction {
    @property({ type: Enum(AudioType), displayName: DEV && '音效類型', tooltip: DEV && '音效類型' })
    public readonly audioType: AudioType = AudioType.Effect;
    @property({ type: Enum(AudioActionType), displayName: DEV && '操作類型', tooltip: DEV && '要進行什麼行為' })
    public readonly type: AudioActionType = AudioActionType.Play;
    @property({
        displayName: DEV && '音效名稱',
        tooltip: DEV && '音效名稱',
        visible(this: AudioAction) {
            return !(this.type === AudioActionType.Stop && this.audioType === AudioType.Music);
        },
    })
    public readonly audioName: string = '';
    @property({
        displayName: DEV && '循環播放',
        tooltip: DEV && '是否為循環播放(loop)',
        visible(this: AudioAction) {
            return this.type === AudioActionType.Play;
        },
    })
    public readonly loop: boolean = false;
    @property({
        displayName: DEV && '音量設定',
        tooltip: DEV && '初始音量設定 (volumeRate, 範圍: 0 ~ 1)',
        visible(this: AudioAction) {
            return this.type === AudioActionType.Play;
        },
    })
    public readonly volumeRate: number = 1;
    @property({
        type: CCInteger,
        displayName: DEV && 'BGM Index',
        tooltip: DEV && '音樂播放編號 (musicIndex)',
        visible(this: AudioAction) {
            return this.audioType === AudioType.Music;
        },
    })
    public readonly musicIndex: number = 1;
}
